
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.9","height":"19.885"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_27681","data-name":"Path 27681","d":"M316.531 238.556a1.552 1.552 0 00-1.439-1.009h-3.608v-5.064a1.555 1.555 0 00-1.547-1.558h-.005a1.556 1.556 0 00-1.411.906l-4.648 10.158a1.55 1.55 0 00.762 2.056 1.581 1.581 0 00.649.142h3.594v5.06a1.554 1.554 0 001.541 1.563h.011a1.555 1.555 0 001.411-.906l4.648-10.16a1.537 1.537 0 00.042-1.187zm-6.062 10.7v-5.4a1.26 1.26 0 00-1.26-1.259l-3.891.058 4.573-10.172v5.4a1.263 1.263 0 001.259 1.26h3.865z","transform":"translate(-303.73 -230.924)","fill":"#262626"}})])
          )
        }
      }
    